<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <dx-toolbar class="toolbar-details theme-dependent">
      <dxi-item location="before">
        <dx-button icon="arrowleft" stylingMode="text"></dx-button>
      </dxi-item>
      <dxi-item location="before" [text]="taskName"></dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <dx-drop-down-button text="Actions" stylingMode="text" [dropDownOptions]="{ width: 'auto' }">
          <dxi-item text="Duplicate"></dxi-item>
          <dxi-item text="Close"></dxi-item>
          <dxi-item text="Delete"></dxi-item>
        </dx-drop-down-button>
      </dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Attach',
          icon: 'attach',
          stylingMode: 'text'
        }"
      ></dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Refresh',
          icon: 'refresh',
          onClick: refresh,
          stylingMode: 'text'
        }"
      ></dxi-item>
    </dx-toolbar>

    <div class="panels">
      <div class="left">
        <dx-validation-group>
          <task-form [task]="task" [isLoading]="isLoading"></task-form>
        </dx-validation-group>
      </div>

      <div class="right theme-dependent">
        <div class="dx-card details-card">
          <dx-tab-panel
            secondary="secondary"
            [focusStateEnabled]="false"
            [showNavButtons]="true"
            [deferRendering]="false"
          >
            <dxi-item title="Activities">
              <card-activities
                [isLoading]="isLoading"
                [activities]="task?.activities"
                [showBy]="true"
              ></card-activities>
            </dxi-item>
            <dxi-item title="Notes">
              <card-notes
                [items]="task?.notes"
                [user]="task?.owner"
              ></card-notes>
            </dxi-item>
            <dxi-item title="Messages">
              <card-messages
                [items]="task?.messages"
                [user]="task?.owner"
              ></card-messages>
            </dxi-item>
          </dx-tab-panel>
        </div>
      </div>
    </div>
  </div>
</dx-scroll-view>
